import React, { useState } from 'react';
import DENTModalOverviewSurfaces from '../DENTModalOverviewSurfaces/DENTModalOverviewSurfaces';
import DENTModalOverviewPathologyToothWear, {
	isSurfaceBasedToothWearType,
	SurfaceBasedToothWearType,
} from '../DENTModalOverviewPathologyButtons/DENTModalOverviewPathologyToothWear';
import useToothWearSurfaceHandler from '../../Hooks/Tooth/Pathology/useToothWearSurfaceHandler';

const DENTToothQuickPathologyModalToothWearButtons = () => {
	const [selectedSurfaceType, setSelectedSurfaceType] = useState<
		SurfaceBasedToothWearType | undefined
	>();
	const surfaceHandler = useToothWearSurfaceHandler(selectedSurfaceType);

	return (
		<>
			<DENTModalOverviewPathologyToothWear
				onTypeChange={type =>
					setSelectedSurfaceType(
						type && isSurfaceBasedToothWearType(type) ? type : undefined,
					)
				}
			/>
			{selectedSurfaceType && (
				<DENTModalOverviewSurfaces
					onSelectSurface={surfaceHandler.handleSelectSurface}
					surfaces={{
						...surfaceHandler,
						shouldShowSurfaces: true,
					}}
				/>
			)}
		</>
	);
};

export default DENTToothQuickPathologyModalToothWearButtons;
